// src/routes/PublicRoute.tsx
import { Navigate } from "react-router-dom";
import { ReactElement } from "react";
import { useAuth } from "../context/AuthContext";

type PublicRouteProps = {
    children: ReactElement;
};

const PublicRoute = ({ children }: PublicRouteProps): ReactElement => {
    return children;
};

export default PublicRoute;

